import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux'
import store from './_slices/AppSlice'
import { IdleTimeout } from './_screens'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      <IdleTimeout timeout={600000} onIdle={() => {
        localStorage.clear();
        // Perform any other actions you need when the application is idle.
        return window.location.reload()
      }} />
    </Provider>
  </React.StrictMode>
);
